import { render, staticRenderFns } from "./AyudaAccesoSistema.vue?vue&type=template&id=963c0e52&scoped=true"
import script from "./AyudaAccesoSistema.vue?vue&type=script&lang=js"
export * from "./AyudaAccesoSistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963c0e52",
  null
  
)

export default component.exports